module.exports = __webpack_public_path__ + "img/whatsapp.4c44b889.svg";